// DS: i10.7
import React from 'react';
import IconWrap from '../IconWrap';
const Patreon = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M4 20h3V3H4zM21 9A6 6 0 1 1 9 9a6 6 0 1 1 12 0"
    }))));
Patreon.displayName = 'Patreon';
export default Patreon;
